import { render, staticRenderFns } from "./UploadPrivateFileOcr.vue?vue&type=template&id=eb2b83f2&scoped=true&"
import script from "./UploadPrivateFileOcr.vue?vue&type=script&lang=js&"
export * from "./UploadPrivateFileOcr.vue?vue&type=script&lang=js&"
import style0 from "./UploadPrivateFileOcr.vue?vue&type=style&index=0&id=eb2b83f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2b83f2",
  null
  
)

export default component.exports